import { APIRoute } from '@/modules/utils'

export type UserPartnerOptin = {
  identifier: string
  affiliationDate: string
  optinSlug: string
  optinText: string
  freeField: string | null
  frontMetadata: string | null
}

export type UserPartnerOptinInput = {
  optinSlug: string
  optinText: string
  freeField?: string | null
  frontMetadata?: string | null
}

export const GetRoute: APIRoute = {
  method: 'GET',
  path: '/v3/partnership/optins',
}

export const PostRoute: APIRoute = {
  method: 'POST',
  path: '/v3/partnership/optins',
}

export const DeleteRoute = (optinSlug: string): APIRoute => ({
  method: 'DELETE',
  path: `/v3/partnership/optins/${encodeURIComponent(optinSlug)}`,
})

export type GetResponse = UserPartnerOptin[]
export type PostBody = UserPartnerOptinInput
export type PostResponse = UserPartnerOptin
export type DeleteResponse = void
